import type { Severity } from '@opensentry/shared';
import { AlertTriangle, Info, OctagonAlert, ShieldAlert } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';

const COLORS: Record<Severity, string> = {
  low: 'var(--color-sev-low)',
  medium: 'var(--color-sev-medium)',
  high: 'var(--color-sev-high)',
  critical: 'var(--color-sev-critical)',
};

// An icon per severity so meaning never depends on color alone (WCAG 1.4.1).
const ICONS: Record<Severity, LucideIcon> = {
  low: Info,
  medium: ShieldAlert,
  high: AlertTriangle,
  critical: OctagonAlert,
};

export function SeverityIcon({ severity, size = 13 }: { severity: Severity; size?: number }) {
  const Icon = ICONS[severity];
  return <Icon size={size} aria-hidden style={{ color: COLORS[severity] }} />;
}

export function SeverityPill({ severity }: { severity: Severity }) {
  const Icon = ICONS[severity];
  return (
    <span
      className="inline-flex items-center gap-1 rounded-full px-2 py-0.5 text-[11px] font-semibold uppercase tracking-wide"
      style={{ background: `${COLORS[severity]}22`, color: COLORS[severity] }}
    >
      <Icon size={12} aria-hidden />
      {severity}
    </span>
  );
}

export { COLORS as SEVERITY_COLORS, ICONS as SEVERITY_ICONS };
